import { AfterViewChecked, ChangeDetectorRef, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SecondAuthLevelService } from '../../../../auth/second-auth-level.service';
import { SessionService } from '../../../../auth/session.service';
import { promiseWithCatch, safelyDetectChanges } from '../../../../common/app.helpers';
import { OperationInfoService } from '../../../../common/long-operations/operation-info.service';
import ProjectLinks from '../../../../common/project.links';
import { DialogActionTypes } from '../../../../notifications/dialogs/dialogs.enum';
import { NotificationContextAttributesService } from '../../../../notifications/notifications-context-attributes.service';
import { FormFieldSate } from '../form-field.state';

@Component({
  selector: 'app-authenticator-binding-field',
  templateUrl: './authenticator-binding-field.component.html',
  styleUrls: ['./authenticator-binding-field.component.scss'],
})
export class AuthenticatorBindingFieldComponent extends FormFieldSate implements AfterViewChecked {
  public hasBoundAuthenticator = false;
  public userEmail = '';

  private sessionService = inject(SessionService);
  private secondAuthLvlService = inject(SecondAuthLevelService);
  private operationInfoService = inject(OperationInfoService);
  private modalAttributesService = inject(NotificationContextAttributesService);
  private changeDetector = inject(ChangeDetectorRef);
  protected router = inject(Router);

  public override ngOnInit(): void {
    super.ngOnInit();
    this.setupStartValue();
    this.subscribeOnAuthenticatorUnbounded();
  }

  public ngAfterViewChecked(): void {
    safelyDetectChanges(this.changeDetector);
  }

  private subscribeOnAuthenticatorUnbounded(): void {
    this.subscriptions.push(
      this.secondAuthLvlService.authenticatorUnbounded.subscribe(() => {
        this.hasBoundAuthenticator = false;
        this.sessionService.updateUserAuthorisationSettings({ has_bound_authenticator: false });
      }),
    );
  }

  private setupStartValue(): void {
    this.hasBoundAuthenticator = this.control.value as boolean;
    this.userEmail = this.sessionService.user.profile.email ?? '';
  }

  public bindAuthenticator(): void {
    promiseWithCatch(
      this.router.navigate([ProjectLinks.BIND_AUTHENTICATOR], {
        state: {
          bindAuthenticator: true,
          previousPage: ProjectLinks.LINK_PROFILE_EDIT,
          email: this.userEmail,
        },
      }),
    );
  }

  public unbindAuthenticator(): void {
    this.operationInfoService.setupOperation(
      {
        spinner: 'global',
        successfulMessage: 'UNBIND_AUTHENTICATOR_SUCCESS_DESCRIPTION',
        confirmationDialog: {
          description: 'UNBIND_AUTHENTICATOR_DESCRIPTION_HINT',
          title: 'UNBIND_AUTHENTICATOR_TITLE_HINT',
          buttons: [
            this.modalAttributesService.createDialogButton('BTN_CLOSE_HINT'),
            this.modalAttributesService.createDialogButton(
              'UNBIND_CONFIRMATION_BTN_HINT',
              'btn-primary',
              DialogActionTypes.CONFIRM_ACTION,
            ),
          ],
        },
      },
      () => {
        this.secondAuthLvlService.unbindAuthenticator();
      },
    );
  }
}
